import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function HintButtonInfo(props) {
  const className = `${style.hintButtonInfo} ${props.className}`;
  return (
    <div className={className}>
      <span>
        {props.hintsLeft} /{props.totalHints}
      </span>
      Hints
    </div>
  );
}

HintButtonInfo.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * Number of hints left
   */
  hintsLeft: PropTypes.number,
  /**
   * total number of hints available
   */
  totalHints: PropTypes.number,
};

HintButtonInfo.defaultTypes = {
  className: '',
};
